import {
  Button,
  Container,
  Copy,
  Flex,
  Heading as TextHeader,
  Image,
  Square,
  Stack,
} from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import EnterpriseLayout from 'src/components/enterprise/layout/EnterpriseLayout';
import Layout from 'src/components/Layout/Layout';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import { getWindow } from 'src/utilities/window';

const IMAGE_MOBILE_WIDTH = '224px';
const HEADER_MOBILE_WIDTH = '230px';

export default function Page404(): JSX.Element {
  const { isDesktop } = useScreenSizes();
  const window = getWindow();

  function goToSignup() {
    window.location.href = `${window.location.origin}/corporate/signup`;
  }

  function isSignupFlow() {
    return /\/corporate\/signup/.test(window.location.pathname);
  }

  function isEnterprisePath() {
    return /\/corporate\/enterprise/.test(window.location.pathname);
  }

  function getPageContent(): JSX.Element {
    return (
      <Container variant="default">
        <Flex
          className="hasFixedSignupNavBar"
          justifyContent={!isDesktop ? 'center' : 'space-between'}
          alignItems="center"
          flexDirection={!isDesktop ? 'column-reverse' : 'row'}
        >
          <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems={!isDesktop ? 'center' : 'flex-start'}
          >
            <Stack y="md" width={!isDesktop ? HEADER_MOBILE_WIDTH : 'auto'}>
              <TextHeader variant="large" textAlign="center">
                There’s nothing cooking here
              </TextHeader>
            </Stack>
            <Stack y="x-lg">
              <Copy variant="massiveLead">This page is not on the menu.</Copy>
            </Stack>
            {isSignupFlow() && (
              <Square width="266px">
                <Button
                  variant="primary"
                  buttonSize="medium"
                  block
                  onClick={goToSignup}
                >
                  Go back to account setup
                </Button>
              </Square>
            )}
          </Flex>

          <Stack y="lg">
            <Image
              width={!isDesktop ? IMAGE_MOBILE_WIDTH : 'auto'}
              src="https://res.cloudinary.com/grubhub-assets/image/upload/v1612881363/corp-management-ui/Error_Illustration.svg"
              role="presentation"
              alt=""
            />
          </Stack>
        </Flex>
      </Container>
    );
  }

  return (
    <>
      {/* Ensures that navigation for self-service does not show as part of enterprise and vice versa */}
      {isEnterprisePath() ? (
        <EnterpriseLayout hideNavigationMenu pageTitle="404">
          {getPageContent()}
        </EnterpriseLayout>
      ) : (
        <Layout title="404" isSignupFlow={isSignupFlow()}>
          {getPageContent()}
        </Layout>
      )}
    </>
  );
}
